import { m, domAnimation, LazyMotion } from 'framer-motion';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function MotionLazy({ children }: Props) {
  return (
    // domAnimation covers variants/exit/hover/tap/inView — everything used here.
    // domMax would additionally bundle drag + layout, which nothing uses
    // (drag-and-drop goes through @dnd-kit).
    <LazyMotion strict features={domAnimation}>
      <m.div style={{ height: '100%' }}> {children} </m.div>
    </LazyMotion>
  );
}
